import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {Group} from '../../graphql/groups.datatypes';
import {gqlGroupMember, gqlGroupOption} from './getGroupMember.api';
import {GET_GROUP_QUERY} from './getGroupByRef.api';

interface GroupByRefData {
    group: void
    groupByRef: Group
}

export const getGroupByRefQuery = (query: string) => {
    return gql`
        query getGroupByRef($booking_form_url: String!){
            groupByRef(booking_form_url: $booking_form_url){
                ${query}
            }
        }
    `;
}

export const getGroupByRefWithQuery = (groupRef: string | null, query: string) => {
    return useQuery<GroupByRefData>(
        getGroupByRefQuery(query),
        {
            variables: {booking_form_url: groupRef}
        }
    );
};

export default getGroupByRefWithQuery;